import { IconNameV2 } from 'common/icon/iconV2.js';
import { Reference } from 'common/reference/reference.js';
import { SummaryItem } from 'components.modules.gen/category-summary/item.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';
import { StatusRating } from 'utilities/status/status-rating.js';
import { IntegrationsConditionsType } from './types.js';

export interface ISunProtectionData {
  uvTitle: string;
  uvHasAlert: boolean;
  uvAlertLevel: string;
  uvMessage?: Array<string> | string;
  uvStartTime: string;
  uvEndTime: string;
  uvProvider?: string;
  uvProviderURL?: string;
  uvProviderImage?: string;
  icon: IconNameV2;
  status?: StatusRating;
}

export type UVProps = IntegrationsConditionsType<{
  sunProtection?: ISunProtectionData;
}>;

export const UVContent = ({ uvData }: { uvData?: UVProps }) => {
  if (uvData) {
    const { displayEndOfSeasonMessage, endOfSeasonMessage, sunProtection, tagline, sponsorImage, sponsorURL } = uvData;

    if (displayEndOfSeasonMessage) {
      if (endOfSeasonMessage) {
        return (
          <SummaryItem
            icon={sunProtection?.icon || 'uv-risk'}
            dataModule={'uv-content'}
            content={[endOfSeasonMessage]}
          />
        );
      }
      return null;
    } else {
      if (sunProtection) {
        const { uvAlertLevel, uvMessage, uvProvider, uvProviderURL, uvProviderImage, uvTitle, icon, status } =
          sunProtection;
        const uvMessages = !(uvMessage instanceof Array) ? [uvMessage].filter(isNotNullOrUndefined) : uvMessage;
        return (
          <SummaryItem
            icon={icon || 'uv-risk'}
            dataModule={'uv-content'}
            title={uvTitle}
            subTitle={[{ text: uvAlertLevel, state: status }]}
            content={uvMessages}
          >
            <Reference
              image={uvProviderImage}
              text={uvProvider}
              url={uvProviderURL}
              maxHeight={1}
              classes="u-mT-xs u-mB-xs"
            />
            <Reference image={sponsorImage} text={tagline} url={sponsorURL} classes="u-mT-xs u-mB-xs" />
          </SummaryItem>
        );
      }
      return null;
    }
  }
  return null;
};
